/**
 * Hide LiveView reconnect toasts unless the main LV is actually in an error state.
 * Nav briefly disconnects the socket; without this, reconnect banners flash spuriously.
 */
export function hideReconnectFlashBannersUnlessLiveViewError(): void {
  const main = document.querySelector('[data-phx-main]');
  const inErrorState =
    main?.classList.contains('phx-client-error') ||
    main?.classList.contains('phx-server-error');
  if (inErrorState) return;
  for (const id of ['client-error', 'server-error']) {
    document.getElementById(id)?.setAttribute('hidden', '');
  }
}
